import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import { Query } from '../Query';

export class QueryTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any = queryResponse;
		if (queryResponse) {
			const { queryTransformOptions } = this.options;
			if (queryTransformOptions) {
				const query = new Query(queryTransformOptions, this.translationHelper, (this.callStackLevel || 1) + 1);
				response = query.execute({
					...executionOptions,
					responseContext: response,
				});
			}
		}
		return response;
	}
}